import { render, staticRenderFns } from "./TrainingFileViewer.vue?vue&type=template&id=406f1453&scoped=true"
import script from "./TrainingFileViewer.vue?vue&type=script&lang=js"
export * from "./TrainingFileViewer.vue?vue&type=script&lang=js"
import style0 from "./TrainingFileViewer.vue?vue&type=style&index=0&id=406f1453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f1453",
  null
  
)

export default component.exports